








































































import { Anagrafica } from '@/models/anagrafica.model';
import { Page } from '@/models/page.model';
import { Component, Prop, Vue } from "vue-property-decorator";
import AnagraficaTable from '../AnagraficaTable.vue';
import StpTable from './StpTable.vue';

@Component({
	components: {
		StpTable,
		AnagraficaTable
	}
})
export default class StpDetail extends Vue {
	@Prop() anagrafica!: Anagrafica;

	page?: Page = new Page(100)

	ordine: string = process.env.VUE_APP_ORDINE;

	get indirizzoText() {
		const s = [];
		if (this.anagrafica.indirizzo) s.push(this.anagrafica.indirizzo);
		if (this.anagrafica.cap) s.push(this.anagrafica.cap);
		if (this.anagrafica.comune) s.push(this.anagrafica.comune);
		if (this.anagrafica.provincia && this.anagrafica.provincia != this.anagrafica.comune) s.push(this.anagrafica.provincia);
		return s.join(" ");
	}

}
